import { Aspect } from '@teambit/harmony';

export const UserAgentAspect = Aspect.create({
  id: 'teambit.ui-foundation/user-agent',
});

export default UserAgentAspect;
